import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

// Add a job to a candidate
export const addJobToCandidate = async (candidateId: string, jobId: string) => {
    try {
        // Check if the job already exists for this candidate
        const { data: existingMatch } = await supabase
            .from('matches')
            .select('id')
            .eq('candidate_id', candidateId)
            .eq('job_id', jobId)
            .single();

        if (existingMatch) {
            toast({
                title: "Warning",
                description: "This job is already in the candidate's process",
            });
            return false;
        }

        // Add job to candidate with initial stage "matched"
        const { data, error } = await supabase
            .from('matches')
            .insert({
                candidate_id: candidateId,
                job_id: jobId,
                score: 0, // Initial score, will be calculated later
                status: 'matched'
            })
            .select('id'); // Return the new match ID

        if (error) throw error;

        if (!data || data.length === 0) {
            throw new Error("Failed to add job to candidate");
        }

        // Trigger AI analysis for the new match
        await supabase.functions.invoke('ai-processing?command=push-new-analysis', {
            method: 'POST',
            body: {
                entityId: data[0].id, // Use the match ID as entityId
                entityType: "match",
                analysisType: "full-match",
                actionOnComplete: "update-match",
            }
        });

        toast({
            title: "Success",
            description: "AI analysis triggered for new match",
        });

        return true;
    } catch (error) {
        console.error('Error adding job to candidate:', error);
        toast({
            title: "Error",
            description: "Failed to add job to candidate's process",
            variant: "destructive",
        });
        return false;
    }
}; 